export const containsEmoji = (value: string) => /\p{Extended_Pictographic}/gu.test(value);
